import {Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AlertController, LoadingController, ModalController, Platform} from '@ionic/angular';
import * as actionsUi from './mandantenverwaltung-typspezifikation.actions.ui';
import * as fromMandantModule from '@orga-app/mandant/reducer';
import * as fromMandantenverwaltungPage from './mandantenverwaltung-typspezifikation.reducer';
import {select, Store} from '@ngrx/store';
import {Observable, Subject} from 'rxjs';
import {DOCUMENT} from '@angular/common';
import {Settings, SettingsProvider} from '@orga-app/settings';
import {
    getAdminRollen, getAdminRollenFehler,
    getAdminRollenLaden,
    getAdminRollenLoeschenAktiv, getAdminRollenSelected,
    getFelderIds,
    getSelectedPandemieTypConfig,
    getSelectedTyp, getSelectedTypDetail, getSelectedTypDetailFehler, getSelectedTypDetailLaden, getSelectedTypFeld, getSelectedTypFelder, getSelectedTypFelderFehler, getSelectedTypFelderFuerGruppe,
    getSelectedTypFelderLaden, getSelectedTypFeldSelectedFeldOption,
    getVeranstaltungsTypen,
    getVeranstaltungsTypenFehler,
    getVeranstaltungsTypenLaden
} from './mandantenverwaltung-typspezifikation.selectors';
import {takeUntil, takeWhile} from 'rxjs/operators';
import {SafeUrl} from '@angular/platform-browser';
import {FeldTyp} from './mandantenverwaltung-typspezifikation.model';
import {getTheme} from '@orga-app/settings/reducer';
import {getIstPandemieLizenzAktiv} from '@orga-app/mandant/reducer';
import {DocumentService} from '@orga-app/providers/document.service';
import {UuidService} from '@orga-app/providers/uuid.service';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {ListInputItem} from '../../shared/sopi-list/sopi-list.model';
import {Landkreis, PandemieVeranstaltungTypKonfiguration} from 'src/clients/pandemie';
import {JsonEditorPage} from '../modale/json-editor/json-editor.page';
import {FeldOptionPage} from '../modale/feld-option/feld-option.page';
import {VeranstaltungsTyp, VeranstaltungsTypFeld, VeranstaltungsTypFeldSelectOption, VeranstaltungsTypIdArrayRequest, VeranstaltungsTypDetail} from '../../../clients/veranstaltungstypen';
import {PostVeranstaltungsTypFelderSortierenAction} from '../../../client-ngrx/veranstaltungstypen';

import {Datenquelle} from '../../verwaltung/rollenselektion/rollenselektion.model';
import {RollenselektionPage} from '../../verwaltung/rollenselektion/rollenselektion.page';
import {AdminRollenHinzufuegenAction, AdminRollenLadenAction, AdminRollenSetzenAction} from './mandantenverwaltung-typspezifikation.actions.ui';


@Component({
    selector: 'page-mandantenverwaltung-typspezifikation',
    templateUrl: './mandantenverwaltung-typspezifikation.page.html',
})
export class MandantenverwaltungTypspezifikationPage implements OnInit, OnDestroy {
    @ViewChild('logoFileInput', {static: false, read: ElementRef}) logoFileInput: ElementRef;

    selectedTheme: Settings;
    public settings$: Observable<Settings>;
    themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;

    // UI
    innererTab = 'Einstellungen';

    private aiName = 'MandantenverwaltungPage';
    private alive = true;

    public istPandemieLizenzAktiv$: Observable<boolean>;

    public selectedPandemieTypConfig$: Observable<PandemieVeranstaltungTypKonfiguration>;

    public veranstaltungsTypen$: Observable<Array<ListInputItem>>;
    public veranstaltungsTypenLaden$: Observable<boolean>;
    public veranstaltungsTypenFehler$: Observable<boolean>;

    public selectedTyp$: Observable<VeranstaltungsTyp>;

    public selectedTypDetail$: Observable<VeranstaltungsTypDetail>;
    public selectedTypDetailLaden$: Observable<boolean>;
    public selectedTypDetailFehler$: Observable<boolean>;

    // Rollen / Berechtigungen
    public adminRollenLoeschenAktiv$: Observable<boolean>;
    public adminRollenSelected$: Observable<Array<string>>;
    public adminRollen$: Observable<Array<ListInputItem>>;
    private adminRollen: Array<ListInputItem>;
    public adminRollenLaden$: Observable<boolean>;
    public adminRollenFehler$: Observable<boolean>;


    // Felder
    public selectedTypFelder$: Observable<Array<ListInputItem>>;
    public selectedTypFelderFuerGruppe$: Observable<Array<VeranstaltungsTypFeld>>;
    public selectedTypFelderLaden$: Observable<boolean>;
    public selectedTypFelderFehler$: Observable<boolean>;

    public selectedTypFeld$: Observable<VeranstaltungsTypFeld>;
    public selectedFeldSelectOption$: Observable<VeranstaltungsTypFeldSelectOption>;

    public felderIds$: Observable<Array<string>>;

    public feldTypen: Array<FeldTyp> = [
        {key: 'TEXT', beschreibung: 'Texteingabe'},
        {key: 'INT', beschreibung: 'Zahleingabe'},
        {key: 'SELECT', beschreibung: 'Auswahlfeld'},
        {key: 'TOGGLE', beschreibung: 'Ja/Nein'},
        {key: 'GRUPPE', beschreibung: 'Gruppe'},
        {key: 'INTSUM', beschreibung: 'Summen-Gruppe'}];

    private unsubscribe$ = new Subject();

    constructor(public modalCtrl: ModalController,
                private store: Store<fromMandantenverwaltungPage.PageState>,
                private storeMandant: Store<fromMandantModule.ModuleState>,
                public platform: Platform,
                private settings: SettingsProvider,
                public loadingCtrl: LoadingController,
                private documentService: DocumentService,
                public settingsProvider: SettingsProvider,
                private uuid: UuidService,
                public element: ElementRef,
                private alertCtrl: AlertController,
                @Inject(DOCUMENT) private document: Document) {
        this.store.dispatch(new actionsUi.PageStateResetAction());

        this.istPandemieLizenzAktiv$ = this.storeMandant.pipe(select(getIstPandemieLizenzAktiv));

        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.store.pipe(select(getTheme));
        this.settings.getActiveTheme().subscribe(val => this.selectedTheme = val);

        this.selectedPandemieTypConfig$ = this.store.pipe(select(getSelectedPandemieTypConfig));

        this.veranstaltungsTypen$ = this.store.pipe(select(getVeranstaltungsTypen));
        this.veranstaltungsTypenLaden$ = this.store.pipe(select(getVeranstaltungsTypenLaden));
        this.veranstaltungsTypenFehler$ = this.store.pipe(select(getVeranstaltungsTypenFehler));

        this.selectedTyp$ = this.store.pipe(select(getSelectedTyp));

        this.selectedTypDetail$ = this.store.pipe(select(getSelectedTypDetail));
        this.selectedTypDetailLaden$ = this.store.pipe(select(getSelectedTypDetailLaden));
        this.selectedTypDetailFehler$ = this.store.pipe(select(getSelectedTypDetailFehler));

        // Rollen / Berechtigungen
        this.adminRollenLoeschenAktiv$ = this.store.pipe(select(getAdminRollenLoeschenAktiv));
        this.adminRollen$ = this.store.pipe(select(getAdminRollen));
        this.adminRollenLaden$ = this.store.pipe(select(getAdminRollenLaden));
        this.adminRollenFehler$ = this.store.pipe(select(getAdminRollenFehler));
        this.adminRollenSelected$ = this.store.pipe(select(getAdminRollenSelected));

        // Felder
        this.selectedTypFelder$ = this.store.pipe(select(getSelectedTypFelder));
        this.selectedTypFelderFuerGruppe$ = this.store.pipe(select(getSelectedTypFelderFuerGruppe));
        this.selectedTypFelderLaden$ = this.store.pipe(select(getSelectedTypFelderLaden));
        this.selectedTypFelderFehler$ = this.store.pipe(select(getSelectedTypFelderFehler));

        this.selectedTypFeld$ = this.store.pipe(select(getSelectedTypFeld));
        this.selectedFeldSelectOption$ = this.store.pipe(select(getSelectedTypFeldSelectedFeldOption));

        this.felderIds$ = this.store.pipe(select(getFelderIds));
    }

    ngOnInit() {
        this.adminRollen$.pipe(takeUntil(this.unsubscribe$)).subscribe(x => this.adminRollen = x);
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    ionViewWillEnter() {
        this.store.dispatch(new actionsUi.PageStateResetAction());
    }


    dokumentAendernInput<T>($event, dokument: T, propName: string, propTyp: string): T {
        // console.log('event1: ', $event.detail);

        if (propName !== null) {
            if (propTyp === 'date') {
                // DATE
                dokument = Object.assign({}, dokument, {[propName]: this[propName]});
            } else if (propTyp === 'checkbox') {
                // Checkbox
                dokument = Object.assign({}, dokument, {[propName]: $event.detail.checked});
            } else if (propTyp === 'toggle') {
                // Toggle
                dokument = Object.assign({}, dokument, {[propName]: $event.detail.checked});
            } else if (propTyp === 'input') {
                // Input
                dokument = Object.assign({}, dokument, {[propName]: $event.target.value});
            } else if (propTyp === 'value') {
                // Value
                dokument = Object.assign({}, dokument, {[propName]: $event});
            } else {
                // SELECT
                dokument = Object.assign({}, dokument, {[propName]: $event.detail.value});
            }
        }

        return dokument;
    }

    selectedTypChanged(item: VeranstaltungsTyp) {
        this.store.dispatch(new actionsUi.VeranstaltungsTypGewaehlt(item));
    }

    veranstaltungsTypStammEingabe($event: CustomEvent, selectedTypKonfig: VeranstaltungsTypDetail, propName: string, propTyp: string) {
        this.store.dispatch(new actionsUi.VeranstaltungsTypStammInput(this.dokumentAendernInput($event, selectedTypKonfig, propName, propTyp)));
    }

    async jsonEditorLandkreiseOeffnen(object: Array<Landkreis>) {
        if (object === null) {
            object = new Array<Landkreis>();
            object.push({
                landkreis_id: 'xxxx'
                }
            );
        }

        const params = {
            json: JSON.stringify(object),
            untertitel: 'Pandemie - Landkreise'
        };
        const modal = await this.modalCtrl.create({component: JsonEditorPage, componentProps: params});
        modal.onDidDismiss().then((result: any) => {
            if (result != null && result.data) {
                const landkreise: Array<Landkreis> = JSON.parse(result.data.json);
                this.store.dispatch(new actionsUi.PandemieLandkreiseConfigInput(landkreise));
            }
        });

        await modal.present();
    }

    veranstaltungsTypHinzufuegen() {
        this.store.dispatch(new actionsUi.VeranstaltungsTypHinzufuegen());
        this.innererTab = 'Einstellungen';
    }

    async landkreiseExcelHerunterladen() {
        const loading = await this.loadingCtrl.create({
            spinner: 'dots',
            message: 'Das Dokument wird geladen ...',
            translucent: true,
            backdropDismiss: false,
            keyboardClose: true
        });

        await loading.present();

        const url = '/api/pandemie/query/landkreise/excel';
        this.documentService.getDocument(url).pipe(takeWhile(() => this.alive))
            .subscribe(document => {
                    if (document !== null) {
                        loading.dismiss();
                        this.documentService.saveFile(document, 'landkreise');
                    } else {
                        // no content
                        loading.dismiss();
                    }
                },
                error => {
                    alert(error);
                    loading.dismiss();
                }, () => {
                });
    }

    veranstaltungsTypStammSpeichern() {
        this.store.dispatch(new actionsUi.VeranstaltungsTypSpeichern());
    }

    veranstaltungsTypenLaden() {
        this.store.dispatch(new actionsUi.VeranstaltungsTypenLaden());
    }

    // Berechtigungen
    adminRollenLaden() {
        this.store.dispatch(new AdminRollenLadenAction());
    }

    adminRollenLoeschen() {
        this.store.dispatch(new actionsUi.AdminRollenLoeschenAction());
    }

    async adminRollenAuswahl(verTyp: VeranstaltungsTypDetail) {
        const rollenIds: Array<string> = [];
        this.adminRollen.forEach(rolle => rollenIds.push(rolle.item.rolle.rolle_id));
        const params = {
            titel: verTyp.bezeichnung,
            nichtAnzuzeigendeRollenIds: rollenIds,
            funktionsbereich: '',
            untertitel: 'Admin-Berechtigung',
            alleAnzeigenAuswahlAnzeigen: false,
            alleAnzeigen: true,
            datenquelle: Datenquelle.Benutzerverwaltung
        };
        // console.log('Params: ', params);
        const modal = await this.modalCtrl.create({component: RollenselektionPage, componentProps: params});
        modal.onDidDismiss().then((result: any) => {
            if (result != null && result.data) {
                // console.log('REsult: ', result);
                result.data.ausgewaehlteRollen.forEach((x: string) => {
                    this.store.dispatch(new AdminRollenHinzufuegenAction(result.data.ausgewaehlteRollen));
                });
            }
        });

        await modal.present();
    }

    adminRollenSelectionChanged($event: Array<string>) {
        this.store.dispatch(new AdminRollenSetzenAction($event));
    }

    // Felder
    feldAnlegen() {
        this.store.dispatch(new actionsUi.VeranstaltungsTypFeldHinzufuegen());
    }

    selectedTypFeldChanged(feld: VeranstaltungsTypFeld) {
        this.store.dispatch(new actionsUi.VeranstaltungsTypFeldGewaehlt(feld));
    }

    veranstaltungsTypenFelderLaden() {
        this.store.dispatch(new actionsUi.VeranstaltungsTypFelderLaden());
    }

    feldBearbeitenAbbrechen() {
        this.store.dispatch(new actionsUi.VeranstaltungsTypFeldEingabeAbbrechen());
    }

    feldSpeichern() {
        this.store.dispatch(new actionsUi.VeranstaltungsTypFeldSpeichern());
    }

    trackByFeldTyp(index, item) {
        return item.key;
    }

    veranstaltungsTypFeldEingabe($event: any, selectedTypKonfig: VeranstaltungsTypFeld, propName: string, propTyp: string) {
        this.store.dispatch(new actionsUi.VeranstaltungsTypFeldInput(this.dokumentAendernInput($event, selectedTypKonfig, propName, propTyp)));
    }

    optionBearbeiten(option: VeranstaltungsTypFeldSelectOption, feld: VeranstaltungsTypFeld) {
        this.feldOptionOeffnen(option, feld);
    }

    optionLoeschen(option: VeranstaltungsTypFeldSelectOption) {
        this.store.dispatch(new actionsUi.VeranstaltungsTypFeldSelectOptionLoeschen(option));
    }

    optionHinzufuegen(feld: VeranstaltungsTypFeld) {
        this.feldOptionOeffnen({
            ist_deaktiviert: false,
            option_id: this.uuid.generateUUID(),
            titel: ''
        }, feld);
    }

    async feldOptionOeffnen(object: VeranstaltungsTypFeldSelectOption, feld: VeranstaltungsTypFeld) {
        if (object != null && object != null) {
            const params = {
                titel: feld.titel,
                untertitel: 'Auswahl-Option',
                option: object
            };
            const modal = await this.modalCtrl.create({component: FeldOptionPage, componentProps: params});
            modal.onDidDismiss().then((result: any) => {
                if (result != null && result.data) {
                    const option: VeranstaltungsTypFeldSelectOption = Object.assign({}, object, result.data.option);
                    this.store.dispatch(new actionsUi.VeranstaltungsTypFeldSelectOptionSpeichern(option));
                }
            });

            await modal.present();
        }
    }

    optionGewaelt(option: VeranstaltungsTypFeldSelectOption) {
        this.store.dispatch(new actionsUi.VeranstaltungsTypFeldSelectOptionGewaehlt(option));
    }

    async dropInFeldListe($event: CdkDragDrop<any>) {
        await this.dropInFeldListeNeu({event: $event, item: null});
    }

    async dropInFeldListeNeu(data: {event: CdkDragDrop<any>, item: any}) {
        const $event = data.event;
        // console.log($event);
        this.selectedTypFelder$.subscribe(items => {
            const felder = [...items.map(x => x.item)];
            moveItemInArray(felder, $event.previousIndex, $event.currentIndex);
            const feldIds = felder.map(feld => feld.feld_id);
            const request = <VeranstaltungsTypIdArrayRequest>{
                ids: feldIds,
                veranstaltungstyp_id: felder[0].veranstaltungstyp_id,
            };
            this.store.dispatch(new PostVeranstaltungsTypFelderSortierenAction(request));
        }).unsubscribe();
    }

    async veranstaltungsTypEntfernen() {
        const promptAlert = await this.alertCtrl.create({
            header: 'ACHTUNG',
            message: 'Der ausgewählte Veranstaltungstyp wird gelöscht. Willst du fortfahren?',
            buttons: [
                {
                    text: 'Ja',
                    handler: () => {
                        this.store.dispatch(new actionsUi.VeranstaltungsTypEntfernen());
                    }
                },
                {
                    text: 'Abbrechen',
                    handler: () => {
                    }
                }
            ],
            cssClass: 'alertCustomCss'
        });
        await promptAlert.present();
    }
}
